import _ from 'lodash';
import { getJwt, logout } from '../helpers/auth.js';

// feature-355 A2: a stale/expired token is rejected with extensions.code UNAUTHENTICATED. The
// Apollo→Yoga migration changed the transport of that error from an HTTP 401 (Apollo networkError)
// to a 200 GraphQL error (graphQLErrors[0], networkError null) — so the old onError handler, which
// set `err.networkError.message = '401 UNAUTHENTICATED'`, crashed on the now-null networkError and
// the recovery never ran. Read the code from EITHER shape, clear the dead cookie, and reload as
// anon so public pages load. Guard on getJwt() so an anonymous caller hitting a gated op (no token
// → UNAUTHENTICATED) does NOT reload-loop. Kept out of client.js so it unit-tests without pulling
// in the ApolloClient construction (and its @apollo/client link imports).
export const handleGraphqlError = ({ graphQLErrors, networkError }) => {
  const code = _.get(graphQLErrors, '[0].extensions.code') ||
    _.get(networkError, 'result.errors[0].extensions.code');
  if (code === 'UNAUTHENTICATED' && getJwt()) {
    logout();
    window.location.reload();
  }
};
